import {openAllianceGenome, openDepMap, openGeneCards, openUniProt} from '../../ExternalLinks';
import {ExternalLinkProps} from "../../../types/props";
import {useGeneRefs} from "../../../hooks/useGeneRefs";

import React from 'react';

type ExternalLinkDef = {
  name: string;
  img: string;
  title?: string;
  onClick: () => void;
};

const ExternalLinks: React.FC<ExternalLinkProps> = ({ entrezID, symbol }) => {
  const geneRefs = useGeneRefs();
  const handleAllianceClick = (entrezID: number) => {
    openAllianceGenome(entrezID, geneRefs);
  };

  const external_links: ExternalLinkDef[] = [
    {name: "GeneCards", img: "genecards-banner.png", onClick: () => entrezID !== undefined && openGeneCards(entrezID)},
    {name: "DepMap", img: "depmap-banner.png", onClick: () => symbol && openDepMap(symbol)},
    {name: "Alliance Genome", img: "alliance-genome-banner.png", onClick: () => entrezID !== undefined && handleAllianceClick(entrezID)},
    {name: "UniProt", img: "uniprot-banner.png", onClick: () => symbol && openUniProt(symbol)},
  ];

  return (
    <div className="my-3 px-4 d-flex justify-content-between">
      {external_links.map((link, idx) => (
        <React.Fragment key={link.name}>
          <img
            src={`${process.env.PUBLIC_URL}/images/${link.img}`}
            alt={link.name}
            title={link.title ?? link.name}
            className="icon-ext-links mouse-pointer"
            onClick={link.onClick}
          />
          {idx < external_links.length - 1 && <div className="vr" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ExternalLinks;
